module.exports = __webpack_public_path__ + "static/nexus-mentis-screenshot-068a7cd4e5e212397e52c54931660d2e.png";